import { EU_SUBMISSION_PATHWAYS } from './eu-submission-pathways';

/**
 * The drug & biologic results heading, named like Canada's ("Health Canada New Drug
 * Submission (NDS) — CTD"): the authority, the application, and the format — instead
 * of a bare "eCTD Dossier".
 */

const US_APPLICATIONS: Record<string, string> = {
  nda: 'New Drug Application (NDA)',
  'nda-505b2': '505(b)(2) New Drug Application (NDA)',
  anda: 'Abbreviated New Drug Application (ANDA)',
  bla: 'Biologics License Application (BLA)',
  biosimilar: '351(k) Biosimilar Biologics License Application (BLA)',
};

/** The EU pathway's full label, e.g. "Article 8(3) — full / complete application". */
export function euLegalBasisLabel(pathway: string | null): string | null {
  for (const group of EU_SUBMISSION_PATHWAYS) {
    const option = group.options.find((o) => o.value === pathway);
    if (option) return option.label;
  }
  return null;
}

export function ctdDossierTitle(documentType: string | null, submissionType: string | null): string {
  if (documentType === 'eu_ctd') {
    // "Article 8(3) — full / complete application" → "Article 8(3)".
    const article = euLegalBasisLabel(submissionType)?.split(' — ')[0];
    return article
      ? `EU Marketing Authorisation Application (${article}) — CTD`
      : 'EU Marketing Authorisation Application — CTD';
  }
  const application = US_APPLICATIONS[submissionType ?? ''];
  return application ? `FDA ${application} — eCTD` : 'eCTD Dossier';
}
